/**
 * GuestCounterRow.jsx
 * Created by Michael Bray on 9/22/17.
 */

import React from 'react';
import PropTypes from 'prop-types';

import NumberField from '../NumberField';

const propTypes = {
    id: PropTypes.string,
    guestType: PropTypes.shape({
        key: PropTypes.string,
        type: PropTypes.string,
        label: PropTypes.string,
        description: PropTypes.string
    }),
    validationClass: PropTypes.string,
    count: PropTypes.number,
    disableTextInput: PropTypes.bool,
    maxTotalGuestsReached: PropTypes.bool,
    maxTotalGuests: PropTypes.number,
    changeCount: PropTypes.func,
    isRequired: PropTypes.bool
};

const defaultProps = {
    guestType: {
        key: "",
        type: "",
        label: "",
        description: ""
    },
    count: 0,
    disableTextInput: false,
    maxTotalGuestsReached: false,
    isRequired: false,
    validationClass: ""
};

const GuestCounterRow = (
    { guestType: { type, description, key, label },
        isRequired,
        validationClass,
        count,
        changeCount,
        disableTextInput,
        maxTotalGuestsReached,
        maxTotalGuests,
        id
    }) => {
    return (
        <div
            role="group"
            aria-labelledby={`${id}-counter-row-${type}`}
            className="rec-guest-counter-row">
            <div className="rec-guest-counter-row-type">
                <div className="rec-guest-counter-row-title" id={`${id}-counter-row-${type}`}>
                    {label || type}
                    {isRequired && (
                        <mark title="required">&nbsp;*</mark>
                    )}
                </div>
                <div className="rec-guest-counter-row-description">
                    {description}
                </div>
            </div>
            <NumberField
                id={`${id}-number-field-${type}`}
                className={validationClass}
                isDecreaseDisabled={count === 0}
                isIncreaseDisabled={maxTotalGuestsReached}
                isDisabled={disableTextInput}
                max={maxTotalGuests}
                onChange={(newCount) => changeCount(key, newCount)}
                value={count}
                units={`${type}s`} />
        </div>
    );
}

GuestCounterRow.propTypes = propTypes;
GuestCounterRow.defaultProps = defaultProps;

export default GuestCounterRow;
